module.exports = __webpack_public_path__ + "static/media/sports (2).2cbf4499.webp";